import RRHHLeaveRequestsView from '@/requests/leaves/views/rrhh/listRequestsLeaveRRhh'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/requests/viewLeave/listRequestRrhh',)({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }

    // Validación de roles permitidos: Admin y RRHH
    const { isAdmin, isRRHH, isSupervisor } = context.userRoles;
    if (!isAdmin && !isRRHH &&!isSupervisor ) {
      throw redirect({ to: '/unauthorized' });
    }
  },

  component: RRHHLeaveRequestsView,
})
